// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import { capitalizeFLetter, confirmation_modal, clipboard, fetchApiData, loadAccount } from '../fnc.js'
import ModalPmaAssigningAccount from './ctn/pma/ModalPmaAssigningAccount.js'
import ModalPmaAssigningStores from './ctn/pma/ModalPmaAssigningStores.js'
import ModalPmaStores from './ctn/pma/ModalPmaStores.js'

const refConst = require("../constants.js").v

const initialState = {
	submited: false
}

export default function PMA(props){

	const adminAccess = [
		"-MjVxK86GVBUKL5oNU66", // General admin
		"-ON1qrQ9xBbT0EbKFaTH", // PMA admin
	]

	if(!props.securityClearance(props))	return;

	const [version] = useState("0.9.0");
	const [pmaList, setPmaList] = useState([]);
	const [accList, setAccList] = useState([]);
	const [stores, setStores] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");

	useEffect(() => {
		getAccounts();
		console.info("Load_stores");
		getStores();
	}, [])

	useEffect(() => {
		getPmaList();
	}, [accList, stores])

	let isAdmin = () => {
		let permissions = props.getUser().permissions;
		if(!permissions || !adminAccess)	return false;
		return permissions.some(p => adminAccess.indexOf(p) !== -1);
	}

	let getPmaList = () => {
		fetchApiData("eio", "getPMA", {}, null, (r) => {
			console.info("PMA_LIST", r);
			if(!r.data)	return;
			let accounts = r.data.map((pma) => {
				let userNameList = []
				if(pma.id_account_list){
					console.info("PMA_LIST_3", pma.id_account_list.split(","));
					pma.id_account_list.split(",").map((v) => {
						let acc = accList.find((a) => a.id === parseInt(v));
						if(acc){
							userNameList.push(acc.data_firebase?.email.split("@")[0])
						}
					})
				}
				let storeList = []
				if(pma.id_store_list){
					console.info("PMA_LIST_33", pma.id_store_list.split(","));
					console.info("PMA_LIST_44", stores);
					console.info("PMA_LIST_55", pma.id_store_list);
					pma.id_store_list.split(",").map((v) => {
						let ss = stores.find((a) => a.id === parseInt(v));
						if(ss){
							storeList.push(ss.title)
						}
					})
					console.info("PMA_LIST_66", storeList);
				}
				return {
					...pma,
					assigned_to: userNameList,
					stores_assigned: storeList
				}
			})
			console.info("PMA_LIST_2", accounts);
			setPmaList(accounts ?? []);
		})
	}

	let removePma = (pmaId) => {
		confirmation_modal(props, () => {
			fetchApiData("eio", "deletePMA", { id: pmaId }, null, (r) => {
				console.info("PMA_REMOVE", r);
				if(r.errorInfo && r.errorInfo.length > 0) {
					if(r.errorInfo[0].code == 1451) {
						props.info({error: "This store has PMA attached to it. Please detach each PMA before removal."})
					}else{
						props.info({error: "Failed to remove store"})
					}
				}else{
					if (r.deleted) {
						getPmaList(); // Refresh the list after successful removal
					} else {
						alert('Failed to remove PMA');
					}
				}
			})
		});
	}

	let getAccounts = () => {
		loadAccount({}, (r) => {
			console.info("loadAccount", r);
			setAccList(r.res ?? []);
		})
	}
	let getStores = () => {
		fetchApiData("eio", "getPMAStores", {}, null, (r) => {
			console.info("getPMAStores", r);
			setStores(r.data ?? []);
		})
	}
	let findEmailFromUid = (uid) => {
		let acc = accList.find((v) => v.id_firebase === uid);
		if(acc){
			let email = acc.data_firebase?.email
			return email.split("@")[0];
		}
		return "-"
	}

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				// const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}
	
	return (<div>
		<div className="mb-3 d-flex justify-content-between align-items-center">
			<div className="input-group">
				<div className="input-group-prepend">
					<span className="input-group-text">
						<i className="bi bi-search"></i>
					</span>
				</div>
				<input
					type="text"
					className="form-control"
					placeholder="Search PMAs..."
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
				/>
			</div>
			{
				isAdmin()?
					<div className="btn-group">
						<ModalPmaStores
					{...props}
					className="btn btn-primary ml-3"
					title={<span><i className="bi bi-shop mr-2"></i>Stores<i className="bi bi-gear ml-2"></i></span>}
						/>
					</div> : ""
			}
		</div>
		<table className="table">
			<thead>
				<tr>
					<th><i className="bi bi-hash mr-1"></i>ID</th>
					<th><i className="bi bi-card-text mr-1"></i>Title</th>
					<th><i className="bi bi-person mr-1"></i>Created by</th>
					<th><i className="bi bi-people mr-1"></i>Users Assigned</th>
					<th><i className="bi bi-shop mr-1"></i>Competitor Assigned</th>
					<th><i className="bi bi-box mr-1"></i>Items</th>
					<th><i className="bi bi-calendar mr-1"></i>Date</th>
					{ isAdmin()? <th><i className="bi bi-gear mr-1"></i>Actions</th> : ""}
				</tr>
			</thead>
			<tbody>
			{
				pmaList
					.filter(v => 
						v.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
						findEmailFromUid(v.uid).toLowerCase().includes(searchTerm.toLowerCase())
					)
					.map((v, k) => {

						return <tr key={`pma-${v.id}-${k}`}>
							<td>{v.id}</td>
							<td>
								<a className="pointer text-decoration-none" onClick={(e) => {
									e.preventDefault();
									props.parent.history.push(`/pma/${v.id}`)
								}}>
									<i className="bi bi-link-45deg mr-1"></i>{v.title}
								</a>
							</td>
							<td><i className="bi bi-person-circle mr-1"></i>{findEmailFromUid(v.uid)}</td>
							<td>
								<div style={{
									display: "flex",
									justifyContent: "space-between",
									alignContent: "flex-start",
									alignItems: "flex-start",
								}}>
									<div className="float-left" style={{maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "wrap"}}>
										{
											v.assigned_to.length > 0? v.assigned_to.map((v, k) => {
												return <span key={k} className="badge badge-info mr-2 text-light">
													<i className="bi bi-person-check mr-1"></i>{v}
												</span>
											}) : ""
										}
									</div>
									{
										isAdmin()?
											<div className="btn-group">
												<ModalPmaAssigningAccount
													pma={v}
													pmaAccList={accList}
													title={<i className="bi bi-gear"></i>}
													{...props}
													getPmaList={getPmaList}
												/>
											</div>
											: ""
									}
								</div>
							</td>
							<td>
								<div style={{
								display: "flex",
								justifyContent: "space-between",
								alignContent: "flex-start",
								alignItems: "flex-start",
							}}>
									<div className="float-left" style={{maxWidth: "250px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textWrap: "wrap"}}>
										{
											v.stores_assigned.length > 0? v.stores_assigned.map((v, k) => {
												return <span key={k} className="badge badge-primary mr-2 text-light">
													<i className="bi bi-shop mr-1"></i>{v}
												</span>
											}) : ""
										}
									</div>
									{
										isAdmin()?
											<div className="btn-group">
												<ModalPmaAssigningStores
													pma={v}
													accounts={accList}
													title={<i className="bi bi-gear"></i>}
													{...props}
													getPmaList={getPmaList}
												/>
											</div>
											: ""
									}
								</div>
							</td>
							<td><i className="bi bi-box-seam mr-1"></i>{v.item_count}</td>
							<td><i className="bi bi-calendar-check mr-1"></i>{v.date_created}</td>
							{ isAdmin()?
								<td>
									<div className="btn-group">
										<button 
											type="button"
											className="btn btn-sm btn-outline-danger" 
											onClick={() => removePma(v.id)}
											title="Remove PMA"
										>
											<i className="bi bi-trash"></i>
										</button>
									</div>
								</td>
							: ""}
						</tr>
					})
			}
			</tbody>
		</table>
	</div>);
}